import React, { createContext, useContext, useEffect, useState } from 'react';

const OrgContext = createContext();

export function OrgProvider({ children }) {
  const [selectedOrg, setSelectedOrg] = useState(() => localStorage.getItem('selectedOrg'));
  const [orgNames, setOrgNames] = useState({});
  const [orgs, setOrgs] = useState([]);

  //const storedUser = JSON.parse(localStorage.getItem('username') || 'null');
  //const isSuperadmin = storedUser?.is_superadmin === true || storedUser?.is_superadmin === 'true';

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('username') || 'null');
    const isSuperadmin = user?.is_superadmin === true || user?.is_superadmin === 'true';
  
    async function loadOrgs() {
      try {
        if (isSuperadmin) {
          const res = await fetch(`${process.env.REACT_APP_SERVER_HOST}/org/active`, { credentials: 'include' });
          const data = await res.json();
          const ids = data.map((org) => String(org.id));
          setOrgs(ids);
          setSelectedOrg((prev) => prev && ids.includes(prev) ? prev : ids[0]);
  
          const names = {};
          data.forEach((org) => (names[org.id] = org.name));
          setOrgNames(names);
        } else {
          const filtered = user?.enti?.filter((e) => e.stato_ente === 1) || [];
          const ids = filtered.map((e) => String(e.id_ente));
          setOrgs(ids);
          setSelectedOrg((prev) => prev && ids.includes(prev) ? prev : ids[0]);
  
          const res = await fetch(`${process.env.REACT_APP_SERVER_HOST}/org/active`, { credentials: 'include' });
          const data = await res.json();
          const names = {};
          data.forEach((org) => {
            if (ids.includes(String(org.id))) {
              names[org.id] = org.name;
            }
          });
          setOrgNames(names);
        }
      } catch (err) {
        console.error('Errore caricamento enti:', err);
        setOrgs([]);
      }
    }
  
    loadOrgs();
  }, []); 
  

  useEffect(() => {
    if (selectedOrg) localStorage.setItem('selectedOrg', selectedOrg);
  }, [selectedOrg]);

  return (
    <OrgContext.Provider value={{ selectedOrg, setSelectedOrg, orgs, orgNames }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  return useContext(OrgContext);
}
